console.log("collection.js");

// --- Sort Form ---
// let sortForm = document.querySelector("#sort-form");

// if (sortForm) {
//   let sortBtn = sortForm.querySelector(".sort-btn");

//   sortBtn.addEventListener("click", function (event) {
//     event.preventDefault();
//     let sortSelect = sortForm.querySelector(".sort-select");
//     sortSelect.classList.toggle("active");
//   });
// }

// --- Toggle View ---
let toggleViewBtn = document.querySelector(".toggle-view-btn");
let loop = document.querySelector(".loop");

if (toggleViewBtn) {
  toggleViewBtn.addEventListener("click", function (event) {
    event.preventDefault();

    if (
      !loop.classList.contains("toggle-one") &&
      !loop.classList.contains("toggle-two")
    ) {
      loop.classList.add("toggle-one");
    } else if (loop.classList.contains("toggle-one")) {
      loop.classList.remove("toggle-one");
      loop.classList.add("toggle-two");
    } else if (loop.classList.contains("toggle-two")) {
      loop.classList.remove("toggle-two");
    }
  });
}

//Collections Dropdown Button
let mobileCollectionsBtn = document.querySelector(".mobile-collections-btn");

if (mobileCollectionsBtn) {
  mobileCollectionsBtn.addEventListener("click", function (event) {
    event.preventDefault();
    let dropdown = document.querySelector(".collections-dropdown");
    dropdown.classList.toggle("active");
  });
}

//Split Button
// let splitBtn = document.querySelector(".split-btn");

// if(splitBtn) {
//   splitBtn.addEventListener("click", function(event) {
//     event.preventDefault();
//     let loop = document.querySelector(".focus-loop");
//     loop.classList.toggle("split");
//     splitBtn.classList.toggle("active");
//   });
// }

//Sort Button
let sortForm = document.querySelector("#sort-form");

if (sortForm) {
  let sortBtn = sortForm.querySelector(".sort-btn");

  sortBtn.addEventListener("click", function (event) {
    event.preventDefault();
    let sortSelect = sortForm.querySelector(".sort-select");
    sortSelect.classList.toggle("active");
  });
}